<template>
    <div>
        <div>
            <div style="width: 926px;margin: 0 auto;margin-top: 100px;">
                <Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef" :defaultConfig="toolbarConfig"
                    :mode="mode" />
                <Editor style="height: 500px; overflow-y: hidden;" v-model="valueHtml" :defaultConfig="editorConfig"
                    :mode="mode" @onCreated="handleCreated" />
            </div>
        </div>
        <div style="width: 926px;margin: 0 auto;margin-top: 100px;">
            <div v-html="pagedata" class="w-e-text-container"></div>
        </div>
    </div>
</template>

<script lang='ts' setup>
import { reactive, toRefs, onBeforeUnmount, ref, shallowRef, onMounted } from 'vue'
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

let pagedata = ref(`<h1 id="avjoi">这是h1阿萨德</h1><h2 id="cby4a">1标题1</h2><h3 id="r4ond">1.1阿斯顿撒旦阿萨德啊</h3><table border="0" width="100%" cellpadding="0" cellspacing="0"><tbody><tr><th></th><th></th><th></th><th></th><th></th></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><h3 id="g6b7p">1.2阿诗丹顿撒</h3><table border="0" width="100%" cellpadding="0" cellspacing="0"><tbody><tr><th></th><th></th><th></th><th></th><th></th></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><h3 id="68epy">1.3阿斯顿撒旦</h3><h4 id="fgi8y">1.3.1啊实打实大啊啊啊</h4><p>阿萨德多撒阿萨达大厦阿打算的阿萨德阿萨德按时多大事大的阿萨德阿萨德阿萨德阿萨德阿萨德中国招标投标公共服务平台开发并开源的 CA互认解密组件，旨在确保全国范围内CA互认机制的完整性和可靠性。该组件通过一整套完善的解密模式，包括XML信封解析、文件解密，确保在电子招标投标过程中数据的安全传输和存储，防止因加密或解密操作失败而影响CA互认的有效性。组件支持两种解密模式：</p><h4 id="i1s5m">1.3.2 啊实打实大恶气阿萨德2&nbsp;</h4><pre><code class="Bash">&lt;!-- 核心包依赖 --&gt;
&lt;dependency&gt;
      &lt;groupId&gt;com.cebpubservice.cashare&lt;/groupId&gt;
      &lt;artifactId&gt;cebpubservice-java-sdk-Core&lt;/artifactId&gt;
      &lt;version&gt;x.x.x(点击查看最新版本号)&lt;/version&gt;
&lt;/dependency&gt;
&lt;!-- 加密与解密依赖 --&gt;
&lt;dependency&gt;
      &lt;groupId&gt;com.cebpubservice.cashare&lt;/groupId&gt;
      &lt;artifactId&gt;cebpubservice-CA-CAShare-java-sdk-EncryptAndDecrypt&lt;/artifactId&gt;
      &lt;version&gt;x.x.x(点击查看最新版本号)&lt;/version&gt;
&lt;/dependency&gt;</code></pre><h2 id="tdyh8"><b></b>2标题2</h2><h3 id="aq6mk">2.1前期去去去</h3><table border="0" width="100%" cellpadding="0" cellspacing="0"><tbody><tr><th></th><th></th><th></th><th></th><th></th></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr></tbody></table><h3>2.2前期去去去其味无穷请问</h3><p>阿萨德多撒阿萨达大厦阿打算的阿萨德阿萨德按时多大事大的阿萨德阿萨德阿萨德阿萨德阿萨德中国招标投标公共服务平台开发并开源的 CA互认解密组件，旨在确保全国范围内CA互认机制的完整性和可靠性。该组件通过一整套完善的解密模式，包括XML信封解析、文件解密，确保在电子招标投标过程中数据的安全传输和存储，防止因加密或解密操作失败而影响CA互认的有效性。组件支持两种解密模式：</p>`)



// 使用DOMParser解析HTML字符串
const parser = new DOMParser();
const doc = parser.parseFromString(pagedata.value, 'text/html');





// 初始化结果数组
let result = ref([]);

// 定义要提取的标签类型
const tagsToExtract = ['H2', 'H3', 'H4'];

const logarr = () => {
    tagsToExtract.forEach(tagName => {
        const elements = doc.querySelectorAll(tagName.toLowerCase());
        elements.forEach(element => {
            result.value.push({
                type: tagName.toLowerCase(),
                id: element.id,
                content: element.textContent.trim()
            });
        });
    });

    // 输出结果数组
    console.log(result.value, 'sssssssssssssss');
}

// onMounted(()=>{
//     logarr()
// })
// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef()

// 内容 HTML
const valueHtml = ref('<p>hello</p>')

// 模拟 ajax 异步获取内容
onMounted(() => {
    setTimeout(() => {
        valueHtml.value = '<p>模拟 Ajax 异步设置内容</p>'
    }, 1500)
})

const toolbarConfig = {}
const editorConfig = { placeholder: '请输入内容...', }
// readOnly : true

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
    const editor = editorRef.value
    if (editor == null) return
    editor.destroy()
})

const handleCreated = (editor) => {
    editorRef.value = editor // 记录 editor 实例，重要！
}

let mode = ref('default')  // 或 'simple'

</script>
<style scoped lang="scss">
::v-deep .w-e-text-container {
    padding: 0 10px;
    overflow-y: auto;

    .table-container {
        border: none;
    }

    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    table,
    pre {
        margin: 10px 0;
        line-height: 1.5;
    }

    ul,
    ol {
        margin: 10px 0 10px 20px;
    }

    blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
    }

    // code {
    //     display: inline-block;
    //     background-color: #f1f1f1;
    //     border-radius: 3px;
    //     padding: 3px 5px;
    //     margin: 0 3px;
    // }

    // pre {

    //     code {
    //         display: block;
    //     }
    // }

    table {
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;

        td,
        th {
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            padding: 3px 5px;
            min-height: 30px;
            height: 30px;
        }

        th {
            border-bottom: 2px solid #ccc;
            text-align: center;
            background-color: #f1f1f1;
        }
    }

    &:focus {
        outline: none;
    }

    img {
        cursor: pointer;

        &:hover {
            box-shadow: 0 0 5px #333;
        }
    }

    .w-e-todo {
        margin: 0 0 0 20px;

        li {
            list-style: none;
            font-size: 1em;

            span:nth-child(1) {
                position: relative;
                left: -18px;

                input {
                    position: absolute;
                    margin-right: 3px;
                }

                // 防止其他样式通过属性选择器重置input样式
                input[type=checkbox] {
                    top: 50%;
                    margin-top: -6px;
                }
            }
        }
    }
}
</style>